import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { UnifiedUpdateCard, UnifiedUpdatePost, UnifiedPostType } from './UnifiedUpdateCard';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useUserRole } from '../../context/UserRoleContext';
const READER_VISIBLE_TYPES: UnifiedPostType[] = ['New Release', 'Cover Reveal', 'Audiobook Launch', 'Sale', 'Event Announcement', 'Award Nomination'];
interface TroveActivityFeedProps {
  posts: UnifiedUpdatePost[];
  title: string;
  showTypeFilter?: boolean;
  maxPosts?: number;
}
export const TroveActivityFeed: React.FC<TroveActivityFeedProps> = ({
  posts,
  title,
  showTypeFilter = false,
  maxPosts = 5
}) => {
  const dk = useDarkClasses();
  const {
    isReader
  } = useUserRole();
  const [activeFilter, setActiveFilter] = useState<UnifiedPostType | 'All'>('All');
  // Filter out vendor-only post types when in reader mode
  const rolePosts = isReader ? posts.filter(p => READER_VISIBLE_TYPES.includes(p.type)) : posts;
  const uniqueTypes = Array.from(new Set(rolePosts.map(p => p.type)));
  const filteredPosts = activeFilter === 'All' ? rolePosts : rolePosts.filter(p => p.type === activeFilter);
  const displayedPosts = filteredPosts.slice(0, maxPosts);
  const activeFilterClass = isReader ? dk.isDark ? 'bg-indigo-900/40 text-indigo-300' : 'bg-indigo-100 text-indigo-700' : dk.isDark ? 'bg-purple-900/40 text-purple-300' : 'bg-purple-100 text-purple-700';
  const inactiveFilterClass = dk.isDark ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' : 'bg-gray-100 text-gray-600 hover:bg-gray-200';
  const linkClass = isReader ? 'text-indigo-600 hover:text-indigo-700' : 'text-purple-600 hover:text-purple-700';
  return <section className="mb-10" data-id="element-3430" data-mp="32ggu0vs0184r">
      <div className="flex items-center justify-between mb-4" data-id="element-3431" data-mp="37dqk8dn7pntn">
        <h2 className={`text-xl font-semibold ${dk.isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3432" data-mp="37dyvy27lmn39">
          {title}
        </h2>
        <Link to="/trove/updates" className={`text-sm font-medium flex items-center ${linkClass}`} data-id="element-3433" data-mp="2cqqhm202pwpy">
          View All Updates
          <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-3434" data-mp="2rgphc97a1g7j" />
        </Link>
      </div>

      {showTypeFilter && uniqueTypes.length > 1 && <div className="flex flex-wrap gap-2 mb-4" data-id="element-3435" data-mp="30ft1lgi6k1nm">
          <button onClick={() => setActiveFilter('All')} className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${activeFilter === 'All' ? activeFilterClass : inactiveFilterClass}`} data-id="element-3436" data-mp="30ehzrm8ap3z5">
            All
          </button>
          {uniqueTypes.map(type => <button key={type} onClick={() => setActiveFilter(type)} className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${activeFilter === type ? activeFilterClass : inactiveFilterClass}`} data-id="element-3437" data-mp="35d2yfh7wfflh">
              {type}
            </button>)}
        </div>}

      <div className="space-y-3" data-id="element-3438" data-mp="3ro2w0mufzpyr">
        {displayedPosts.map(post => <UnifiedUpdateCard key={post.id} post={post} data-id="element-3439" data-mp="3cyonti2lreky" />)}
      </div>

      {displayedPosts.length === 0 && <p className={`text-sm py-8 text-center ${dk.isDark ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-3440" data-mp="3hx88zg9dgmc9">
          No activity posts found.
        </p>}
    </section>;
};